import { BASE_API_URL, endpoints } from "@/constants/api";
import { AppDispatch } from "@/store";
import actionsHandler from "@/store/actions/actionHandler";
import { setAuth } from "@/store/slices/authSlice";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

let dispatch: AppDispatch | null = null;
const apiContextHelper = () => {
  let isRefreshingToken = false;
  // ***** Constants *****
  const API_CONFIG = {
    baseURL: BASE_API_URL,
    timeout: 30000, // 30 seconds
    headers: {
      "Content-Type": "application/json",
    },
  } as const;
  const RefreshTokenStatusCode = 428;

  const isRefreshTokenRequest = (error: AxiosError) => {
    return error.config?.url?.includes(endpoints.refreshToken.url);
  };

  const setDispatch = (currentDispatch: AppDispatch) => {
    dispatch = currentDispatch;
  };

  const getDispatch = () => {
    return dispatch as AppDispatch | null;
  };

  const setIsRefreshingToken = (value: boolean) => {
    isRefreshingToken = value;
  };

  const getIsRefreshingToken = () => {
    return isRefreshingToken;
  };
  const getUnStringified = (token: string | null): string => {
    return token?.replaceAll('"', "") ?? "";
  };

  const getToken = (): string | null => {
    return localStorage.getItem("token");
  };

  const refreshToken = async () => {
    if (!dispatch || getIsRefreshingToken()) return;

    setIsRefreshingToken(true);
    const { unAuthenticatedCall: refreshToken } =
      actionsHandler("refreshToken");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const refreshTokenResponse = await dispatch(
      refreshToken({
        payload: {
          refresh_token: getUnStringified(user?.refresh_token),
          email: user?.email,
        },
        method: "post",
      }),
    );
    setIsRefreshingToken(false);
    if (refreshTokenResponse.ok) {
      dispatch(
        setAuth({
          token: refreshTokenResponse.data.token,
          user: { ...user, ...refreshTokenResponse.data },
        }),
      );
      window?.location.reload();
    }
  };

  const createHeaders = (
    isNonAuthenticated: boolean,
    customHeaders: Record<string, string> = {},
  ): Record<string, string> => {
    const headers: any = {
      ...API_CONFIG.headers,
      ...customHeaders,
    };

    if (!isNonAuthenticated) {
      const token = getUnStringified(getToken());
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return headers;
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window?.location.reload();
    toast.warning("Logged out due to inactivity");
  };

  return {
    setDispatch,
    getDispatch,
    setIsRefreshingToken,
    getIsRefreshingToken,
    refreshToken,
    getUnStringified,
    getToken,
    createHeaders,
    handleLogout,
    API_CONFIG,
    RefreshTokenStatusCode,
    isRefreshTokenRequest,
  };
};

export default apiContextHelper;
